import type { StaffRole } from '@baseball-near-you/common';
import type { Team } from '@baseball-near-you/prisma';
import type { ReactNode } from 'react';

export type Step = {
  id: OnboardingStep;
  title: string;
  component: (props: {
    setCurrentStep: (step: OnboardingStep) => void;
    onStepSuccess: () => Promise<void>;
  }) => ReactNode;
  previousStep: OnboardingStep | null;
  nextStep: OnboardingStep | null;
};

export enum OnboardingStep {
  AccountDetails = 'account-details',
  Verification = 'verification',
  Role = 'role',
  Name = 'name',
  Handedness = 'handedness',
  Position = 'position',
  Review = 'review',
  Success = 'success',
  NextSteps = 'next-steps',
  TeamClaim = 'team-claim',
  TeamAdd = 'team-add',
}

export type TeamCreationFormValues = Pick<Team, 'name' | 'phone' | 'email'> & {
  website?: string;
  role: StaffRole | null;
  relation: string;
};
